import React, { useState } from 'react';
import * as Icons from 'lucide-react';
import SiteNav from './marketing/SiteNav';
import SiteFooter from './marketing/SiteFooter';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const submit = (e) => { e.preventDefault(); if (!form.name || !form.email) { toast({ title: 'Please add your name and email' }); return; } setSent(true); toast({ title: 'Message sent', description: 'We\u2019ll be in touch soon.' }); };

  return (
    <div className="min-h-screen bg-background">
      <SiteNav />
      <section className="hero-gradient pt-[68px]">
        <div className="max-w-7xl mx-auto px-6 py-16 text-white"><h1 className="font-display font-extrabold text-4xl md:text-5xl">Contact us</h1><p className="mt-4 text-slate-300 max-w-2xl">Questions about a booking, becoming a contractor, or enterprise & franchise options? Send us a message.</p></div>
      </section>
      <section className="max-w-6xl mx-auto px-6 py-16 grid lg:grid-cols-3 gap-10">
        <div className="space-y-6">
          {[{ icon: 'Mail', label: 'Email', value: 'hello@check-a-property.co.uk' }, { icon: 'Phone', label: 'Phone', value: '0330 123 4567' }, { icon: 'Clock', label: 'Hours', value: 'Mon–Fri, 9am–6pm' }].map((i) => {
            const C = Icons[i.icon];
            return (
              <div key={i.label} className="flex items-start gap-4">
                <div className="h-11 w-11 rounded-xl bg-[#eaf1fb] text-[#1c63c4] flex items-center justify-center shrink-0"><C className="h-5 w-5" /></div>
                <div><div className="text-sm text-muted-foreground">{i.label}</div><div className="font-semibold text-[#102d55]">{i.value}</div></div>
              </div>
            );
          })}
        </div>
        <div className="lg:col-span-2 bg-white border border-border rounded-2xl p-8">
          {sent ? (
            <div className="text-center py-10">
              <div className="h-14 w-14 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mx-auto mb-4"><Icons.CheckCircle2 className="h-7 w-7" /></div>
              <h2 className="font-display font-bold text-2xl text-[#102d55]">Thanks, {form.name.split(' ')[0]}!</h2>
              <p className="text-muted-foreground mt-2">Your message has been received. We’ll reply to {form.email} shortly.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <div className="grid sm:grid-cols-2 gap-5">
                <div><Label>Name *</Label><Input value={form.name} onChange={(e) => set('name', e.target.value)} className="mt-1.5" placeholder="Jane Smith" /></div>
                <div><Label>Email *</Label><Input type="email" value={form.email} onChange={(e) => set('email', e.target.value)} className="mt-1.5" placeholder="you@company.com" /></div>
              </div>
              <div><Label>Message</Label><Textarea value={form.message} onChange={(e) => set('message', e.target.value)} className="mt-1.5" rows={5} placeholder="How can we help?" /></div>
              <Button type="submit" className="bg-[#102d55] hover:bg-[#0b2244]">Send message <Icons.Send className="ml-2 h-4 w-4" /></Button>
            </form>
          )}
        </div>
      </section>
      <SiteFooter />
    </div>
  );
};

export default Contact;
